import API_URLS from '~/core/api-urls'
import store from '~/core/store'
import { translate } from '../core/translate'
import { getSessionParticipants } from '~/selectors/session-details'
import { LINK_TYPES } from '~/core/constants'

import api from './api'

const getNextExpiryTimestamp = url => {
  const expiredSeconds = new URL(url).searchParams.get('X-Amz-Expires')
  const seconds = expiredSeconds ? +expiredSeconds : 1800
  const miliseconds = seconds * 1000

  return new Date().getTime() + miliseconds
}

const normalizeSharedFile = (map, sharedFile) => {
  const participants = getSessionParticipants(sharedFile.sessionId)(store.getState())
  const { name } = participants.find(
    p => p.userId === sharedFile.initiatorId
  ) || {}

  map[sharedFile.objectId] = {
    url: sharedFile.preSignedUrl,
    sender: name || translate('guest'),
    timestamp: sharedFile.timestamp,
    objectId: sharedFile.objectId,
    fileName: sharedFile.fileName,
    fileSizeBytes: sharedFile.fileSizeBytes,
    type: LINK_TYPES.UNKNOWN
  }

  return map
}

const normalizeSharedFiles = items => items.reduce(normalizeSharedFile, {})

const normalizeResponse = (resp, sessionId) => {
  const result = {
    [sessionId]: {
      content: normalizeSharedFiles(resp.content),
      hasMoreSharedFiles: !resp.lastPage,
      lastSharedFilesPageIndex: resp.pageKey
    }
  }

  // base shared files expiry time on the first page of results
  if (resp.pageKey === 0 && resp.content?.length) {
    result[sessionId].nextExpiryTimestamp = getNextExpiryTimestamp(resp.content[0].preSignedUrl)
  }

  return result
}

export const fetchSharedFiles = async (sessionId, lastSharedFilesPageIndex, pageSize) => {
  const pageIndex = lastSharedFilesPageIndex + 1
  let result = await api.get(
    API_URLS.sharedFiles({ sessionId, pageIndex, pageSize })
  )

  if (api.isErrorResponse(result) || result.length === 0) {
    result = {
      [sessionId]: {
        content: {},
        hasMoreSharedFiles: false,
        lastSharedFilesPageIndex
      }
    }
  } else {
    result = {
      content: result.files,
      pageKey: pageIndex,
      lastPage: result.lastPage || !result.files?.length
    }
    result = normalizeResponse(result, sessionId)
  }

  return result
}
